<template>
  <ConfirmationModal
    :cancelText="cancelText"
    :continueText="continueText"
    :enableMainAction="inputValid || enableMainAction"
    :handleCancel="handleCancel"
    :handleContinue="handleContinue"
    :headerText="headerText"
    :loading="loading"
    :mainActionAttention="mainActionAttention"
    :mdTemplate="bodyText"
    :showLoadingOverlay="showLoadingOverlay"
  >
    <template #message>
      <slot name="message" />
    </template>
    <slot />
    <ConfirmationInput
      v-if="confirmationInputConfig"
      :config="confirmationInputConfig"
      @input="handleChangeEvent"
    />
    <p
      v-if="additionalText"
    >
      {{ additionalText }}
    </p>
  </ConfirmationModal>
</template>
<script>
import ConfirmationInput from 'client/components/Modal/ModalComponents/ConfirmationInput.vue';
import ConfirmationModal from 'client/components/Modal/ModalComponents/ConfirmationModal.vue';
import ModalEventBus from 'client/components/Modal/ModalEventBus';

export default {
  name: 'DeleteConfirmationModal',

  inject: ['$validator'],

  components: {
    ConfirmationInput,
    ConfirmationModal,
  },

  props: {
    additionalText: {
      default: '',
      type: String,
    },
    bodyText: {
      default: '',
      type: String,
    },
    cancelText: {
      default: 'cancel',
      type: String,
    },
    confirmationInputConfig: {
      default() {},
      type: Object,
    },
    continueText: {
      default: 'continue',
      type: String,
    },
    enableMainAction: {
      default: false,
      type: Boolean,
    },
    handleCancel: {
      default: () => ModalEventBus.close(),
      type: Function,
    },
    handleContinue: {
      default: () => ModalEventBus.close(),
      type: Function,
    },
    headerText: {
      default: 'An Empty Confirmation Modal',
      type: String,
    },
    loading: {
      default: false,
      type: Boolean,
    },
    mainActionAttention: {
      default: false,
      type: Boolean,
    },
    showLoadingOverlay: Boolean,
  },

  data() {
    return {
      inputValid: false,
    };
  },

  methods: {
    async handleChangeEvent() {
      if (this.confirmationInputConfig) {
        await this.$validator.validate(this.confirmationInputConfig.name);
        this.inputValid = (this.v2Errors.items.length === 0);
      }
    },
  },
};
</script>
